import { Entidad } from "../../../data/Entidad";
import { CFinanzaPagoEnLineaFormaPago } from "../../../data/entidad/FinanzasEstadoCuenta";
import { ID_METODOPAGO_ENLINEA_TEMP, MFinanzaEdoCtaMovimiento } from "../../../data/model/FinanzaEstadoCuenta/MFinanzaEdoCtaMovimiento";
import { MFinanzaEdoCtaMovimientoDetalle } from "../../../data/model/FinanzaEstadoCuenta/MFinanzaEdoCtaMovimientoDetalle";
import { _DICC_METODO_PAGO } from "../../../data/modulo/FinanzaMetodoPago";
import { _DICC_ALUMNO_MOVPAGO_FOLIO } from "../../../data/modulo/FinanzasEstadoCuenta";
import { DataModuloMain } from "../../../data/ModuloMain";
import _L from "../../../util/Labels";
import { Table } from "../../controlD3/Tabla";
import { UIUtilFormat } from "../../util/Format";
import { UIUtilTime } from "../../util/Time";
import { UIUtilViewData } from "../../util/ViewData";
import { AlumnoEdoCtaMovDetalleGeneralModal } from "./AlumnoEdoCtaModals/AlumnoEdoCtaMovDetalleGeneralModal";
import { AlumnoEdoCtaMovDetallePagoModal } from "./AlumnoEdoCtaModals/AlumnoEdoCtaMovDetallePagoModal";

import CCategoriaMov = Entidad.CFinanzaCategoriaMovimiento;

type IMetodoPago = Entidad.IFinanzaMetodoPago;


export namespace AlumnoEdoCtaUtil {
    export enum CTableColumns {
        Periodo = "Periodo",
        Descripcion = "Cargo",
        /** Valor de: Cargo, descuento  */
        Valor = "Valor",
        PagoAbono = "PagoAbono",
        Saldo = "Saldo",
        Recargo = "Recargo",
        FechaVencimiento = "FechaVencimiento",
        FechaPago = "FechaPago",
        MetodoPago = "MetodoPago"
    }

    export type TTableColumns = Pick<
        MFinanzaEdoCtaMovimiento,
        "Periodo" | "Cargo" | "Valor" | "Recargo" | "PagoAbono" | "Saldo" | "FechaVencimiento" | "FechaPago" | "MetodoPago"
    > & {
        Periodo?: string;
        /** Solo para configuración de tabla */
        PagoAbono?: string;
        /** Solo para configuración de tabla */
        FechaPago?: string;
        /** Solo para configuración de tabla */
        MetodoPago?: string;
    }

    export interface ICurrentData {
        IdAlumno: number;
        AlumnoNombre: string;
        NoCuenta: string;
        Tutoes: string[];
        StrNivel: string;

        StrPeriodo: string;
        SaldoPeriodo: number;
        SaldoPendiente: number;
        InteresesGenerados: number;
        TotalPago: number;
        MovimientosPeriodo: MFinanzaEdoCtaMovimiento[];

        MovimientosTbl_TopPeriodo: MFinanzaEdoCtaMovimiento[];
    }

    export const MODULO_PERMISO = Entidad.CModulo.PanelFinanzasEdoCuenta;
    export const MODULO_LANG_KEY = Entidad.CModulo[Entidad.CModulo.PanelFinanzasEdoCuenta].toLowerCase();

    export function GetMetodosPagoList(idEscuela: number): IMetodoPago[] {
        return Array.from(_DICC_METODO_PAGO.values())
            .filter(d => (d.IdEscuela == idEscuela && d.ProveedorElectronico == Entidad.CProveedorMetodoPagoElectronico.SinProveedor));
    }

    export function GetPagoValidation(inputPago: number, cargo: MFinanzaEdoCtaMovimiento) {
        type TFix = ("maxpay" | "minrecargo");
        const saldo = cargo._ObtenerSaldoFinal();
        let decimales = (String(inputPago).split("."))[1];
        let decimalesValidos = (decimales ? (decimales.length > 0 && decimales.length < 3) : true);
        // let isValid = true;
        let message: string;
        let typeFix: TFix = "maxpay";

        if (inputPago <= 0) {
            message = _L("panelfinanzasedocuenta.notif_pagoinvalido")
                .replace("_VALOR", UIUtilFormat._CurrencyFmt(inputPago));
        }
        else if (inputPago < cargo._CalcularAdeudoRecargoPendiente()) {
            message = _L("panelfinanzasedocuenta.notif_pagominrecargo");
            typeFix = "minrecargo";
        }
        else if (inputPago > saldo) {
            message = _L("panelfinanzasedocuenta.notif_pagoexcede");
        }
        else if (!decimalesValidos) {
            message = _L("panelfinanzasedocuenta.notif_cantsinvalid");
        }

        return {
            IsValid: (message == null),
            Message: message,
            TypeFix: typeFix
        }
    }

    export function GetUIStrFieldData<TMode extends ("cargo" | "detalle")>(type: TMode, field: keyof MFinanzaEdoCtaMovimiento, dato: (TMode extends "cargo" ? MFinanzaEdoCtaMovimiento : MFinanzaEdoCtaMovimientoDetalle)) {
        const detalle = ((type == "detalle") ? (dato as MFinanzaEdoCtaMovimientoDetalle) : null);
        const cargo = ((type == "cargo") ? (dato as MFinanzaEdoCtaMovimiento) : null);
        const esPago = (detalle && [CCategoriaMov.PagoParcial, CCategoriaMov.PagoCompleto].includes(detalle.Categoria));
        let strText = "";

        switch (field) {
            case CTableColumns.Periodo:
                if (cargo) {
                    strText = cargo.Periodo;
                }
                break;
            case CTableColumns.Descripcion:
                strText = GetUIStrFieldDataDescripcion(type, dato).getTextPlain();
                break;
            case CTableColumns.Valor: // Cargo | descuento
                if (cargo) {
                    strText = UIUtilFormat._CurrencyFmt(cargo.Valor);
                }
                else if (detalle.Categoria == CCategoriaMov.Descuento) {
                    strText = "-" + UIUtilFormat._CurrencyFmt(detalle.Valor);
                }
                break;
            case CTableColumns.Recargo:
                if (detalle && detalle.Recargo > 0) {
                    strText = UIUtilFormat._CurrencyFmt(detalle.Recargo);
                }
                break;
            case CTableColumns.PagoAbono:
                if (esPago) {
                    strText = "-" + UIUtilFormat._CurrencyFmt(detalle.Valor);
                }
                break;
            case CTableColumns.Saldo:
                strText = (cargo || detalle)?.SaldoForTable || "";
                break;
            case CTableColumns.FechaVencimiento:
                if (cargo) {
                    strText = UIUtilTime._DateFormatStandar(cargo.FechaVencimiento);
                } else if (detalle && detalle._IsPagoOnlinePendiente()) {
                    strText = UIUtilTime._DateFormatStandar(detalle.FechaVencimiento);
                }
                break;
            case CTableColumns.FechaPago:
                if (esPago) {
                    strText = UIUtilTime._DateFormatStandar(detalle.FechaAplicacion);
                }
                break;
            case CTableColumns.MetodoPago:
                if (esPago) {
                    strText = detalle.MetodoPagoInfoCompleta;
                }
                break;
        }
        return strText;
    }

    interface IStrFieldDataDescripcion {
        getTextPlain(): string;
        buildHtml(alumno: Entidad.IAlumno, container: TSelectionHTML<"div">, tabla: Table.Tabla<any>): void;
    }
    export function GetUIStrFieldDataDescripcion(type: "detalle" | "cargo", dato: MFinanzaEdoCtaMovimiento | MFinanzaEdoCtaMovimientoDetalle): IStrFieldDataDescripcion {
        const detalle = ((type == "detalle") ? (dato as MFinanzaEdoCtaMovimientoDetalle) : null);
        // const cargo = ((type == "cargo") ? (dato as MFinanzaEdoCtaMovimiento) : null);

        const getTexts = () => {
            let text = "";
            let subText = "";
            text = dato.Cargo; // cargo | descuento
            if (detalle) {
                switch (detalle.Categoria) {
                    case CCategoriaMov.Morosidad:
                        text = _L("panelfinanzasedocuenta.tag_recargomoroso");
                        break;
                    case CCategoriaMov.LlegadaAnticipada:
                    case CCategoriaMov.SalidaTarde:
                    case CCategoriaMov.PagoParcial:
                    case CCategoriaMov.PagoCompleto:
                        text = UIUtilViewData._GetStr_CategoriaMovimiento(detalle.Categoria);
                        const folioPago = _DICC_ALUMNO_MOVPAGO_FOLIO.get(detalle.FolioPago);
                        if (folioPago) {
                            if (detalle._IsPagoOnlinePendiente()) {
                                text = _L("panelfinanzasedocuenta.tag_conciliacion_pendiente");
                                const subStringMap = {
                                    [CFinanzaPagoEnLineaFormaPago.Tarjeta]: _L("panelfinanzasedocuenta.tag_conciliacion_pendiente_tarjeta"),
                                    [CFinanzaPagoEnLineaFormaPago.TransferenciaBancaria]: _L("panelfinanzasedocuenta.tag_conciliacion_pendiente_referencia"),
                                    [CFinanzaPagoEnLineaFormaPago.Efectivo]: _L("panelfinanzasedocuenta.tag_conciliacion_pendiente_efectivo"),
                                }
                                if (subStringMap[folioPago.FormaPago]) {
                                    subText = `${_L("panelfinanzasedocuenta.tag_folio")}: ${folioPago.Folio}` + "\n" + subStringMap[folioPago.FormaPago];
                                } else {
                                    subText = `${_L("panelfinanzasedocuenta.tag_folio")}: ${folioPago.Folio}`;
                                }
                            } else {
                                subText = `${_L("panelfinanzasedocuenta.tag_folio")}: ${folioPago.Folio}`;
                            }
                        }
                        break;
                }
            }
            return { text, subText };
        }

        const getTextPlain = (): string => {
            const { text, subText } = getTexts();
            if (subText) {
                return `${text}\n${subText}`;
            }
            return text;
        }
        const buildHtml = (alumno: Entidad.IAlumno, container: TSelectionHTML<"div">, tabla: Table.Tabla<any>): void => {
            const { text, subText } = getTexts();
            let template = `<div class="description-head">${text}</div>`;
            if (subText) {
                template += `<span style="font-size: var(--fontsize_me2); font-weight: 300;">${subText}</span>`;
            }

            container.html(template);

            const descriptionContent: HTMLDivElement = container.select<HTMLDivElement>(".description-head").node() as HTMLDivElement;

            const openModalPago = () => AlumnoEdoCtaMovDetallePagoModal({
                Alumno: alumno,
                MovDetalle: detalle,
                OnClickVerOtrosCargos: () => {
                    tabla._SetSearchText(detalle.FolioPago);
                }
            });
            const cellCall = {
                [CCategoriaMov.Descuento]: () => AlumnoEdoCtaMovDetalleGeneralModal("descuento", detalle),
                [CCategoriaMov.Morosidad]: () => AlumnoEdoCtaMovDetalleGeneralModal("morosidad", detalle),
                [CCategoriaMov.PagoCompleto]: openModalPago,
                [CCategoriaMov.PagoParcial]: openModalPago,
            }
            const hasCall: boolean = !!cellCall[detalle.Categoria];
            container.classed("link_item", hasCall);
            if (hasCall) {
                container.node().onclick = e => (e.stopPropagation(), cellCall[detalle.Categoria]());
            }

            // PagoCompleto||PagoParcial: Agregar TagStatusFactura (si aplica)
            const facturaTag = container.select<HTMLDivElement>(".tag_factura").node()
            if (detalle.IdFacturaFolio != 0 && !facturaTag) {
                const facturaFallo = detalle.IdFacturaFolio < 0
                container.append("div")
                    .attr("class", "tag_factura " + (facturaFallo ? "tag_factura_fallo" : "tag_factura_ok"))
                    .text(facturaFallo
                        ? _L("panelfinanzasedocuenta.tag_factura_fallo")
                        : _L("panelfinanzasedocuenta.tag_facturado"));

            } else if (!detalle.IdFacturaFolio && facturaTag) {
                facturaTag.remove()
            }
        }

        return { getTextPlain, buildHtml };
    }

    export function _GetNombreMetodoPago(idMetodoPago: number): string {
        let strText = "";
        if (idMetodoPago) {
            if (idMetodoPago > 0) { // TEMPORAL condición: hasta que OpenPay sea parte de los datos reales
                strText = DataModuloMain._GetDataValueFieldByName("FinanzaMetodoPago", idMetodoPago, "Nombre");
                if (!strText) {
                    strText = _L("general.nodisponible");
                }
            }
            else if (idMetodoPago == ID_METODOPAGO_ENLINEA_TEMP) { // TEMPORAL -1 == Openpay
                strText = "OpenPay";
            }
        } else {
            strText = _L("panelfinanzasedocuenta.tag_efectivo");
        }
        return strText;
    }
}